import __base_store from '@/store/__base_store'

/**
 * Store de tipos de publicación de Mercado Libre (modelo `meli_listing_type`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'meli_listing_type',
	},
})

